module.exports = __webpack_public_path__ + "./img/paradigma-horizontal.9f03b2691c766121fa1a5c0af915fb99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/paradigma-horizontal.jpg
// module id = ./src/assets/img/paradigma-horizontal.jpg
// module chunks = 6